/**
 * FlyFreely API
 *
 * Contact: support@flyfreely.io
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AltitudeValueDto } from './altitudeValueDto';
import { CurrentAttachmentVersionDto } from './currentAttachmentVersionDto';
import { FeatureCollectionWithSprites } from './featureCollectionWithSprites';
import { LinkDto } from './linkDto';
import { LocationFeatureDto } from './locationFeatureDto';
import { NoticeTypeDto } from './noticeTypeDto';
import { SimpleOrganisationDto } from './simpleOrganisationDto';

export interface NoticeDto {
    id: number;
    subject: string;
    description: string;
    startTime: string;
    endTime?: string;
    operatingRequirement: NoticeDto.OperatingRequirement;
    audience: NoticeDto.Audience;
    pointOfContact?: string;
    pointOfContactPhoneNumber?: string;
    importance: NoticeDto.Importance;
    status: NoticeDto.Status;
    location: Array<LocationFeatureDto>;
    attachmentList: Array<CurrentAttachmentVersionDto>;
    linkList: Array<LinkDto>;
    organisation: SimpleOrganisationDto;
    lowerLimit?: AltitudeValueDto;
    upperLimit?: AltitudeValueDto;
    noticeType?: NoticeTypeDto;
    /**
     * The rendered location features
     */
    displayLocation?: FeatureCollectionWithSprites;
}
export namespace NoticeDto {
    export type OperatingRequirement = 'NONE' | 'ACKNOWLEDGE' | 'BLOCK';
    export const OperatingRequirement = {
        NONE: 'NONE' as OperatingRequirement,
        ACKNOWLEDGE: 'ACKNOWLEDGE' as OperatingRequirement,
        BLOCK: 'BLOCK' as OperatingRequirement
    };
    export type Audience = 'GENERAL' | 'FLIGHT_OPERATIONS';
    export const Audience = {
        GENERAL: 'GENERAL' as Audience,
        FLIGHT_OPERATIONS: 'FLIGHT_OPERATIONS' as Audience
    };
    export type Importance = 'LOW' | 'MEDIUM' | 'HIGH';
    export const Importance = {
        LOW: 'LOW' as Importance,
        MEDIUM: 'MEDIUM' as Importance,
        HIGH: 'HIGH' as Importance
    };
    export type Status = 'NEW' | 'PENDING' | 'ACTIVE' | 'CANCELLED';
    export const Status = {
        NEW: 'NEW' as Status,
        PENDING: 'PENDING' as Status,
        ACTIVE: 'ACTIVE' as Status,
        CANCELLED: 'CANCELLED' as Status
    };
}
